import RestClient from './RestClient';
import { QuoteTextTemplate } from '../models';

class QuoteTextTemplates extends RestClient {
    constructor() {
        super({
            model: QuoteTextTemplate,
            entryPoint: 'quote-text-templates',
            id_field: '_id',
            resource: 'quote_text_template',
            resources: 'quote_text_templates',
            sortBy: 'name',
        });
    }
}

const QuoteTextTemplatesApi = new QuoteTextTemplates();
export default QuoteTextTemplatesApi;
